import { nameRegExp, TextFieldForm } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';
import { ExamCandidateDetails } from '../../../../api/candidate/exam/model';
import ToggleDisplayEditFormItem from '../../../../components/ToggleDisplayEditFormItem';
import { useStyles } from './style';
import ControlledCustomSelect from '../../../../components/form-items/ControlledCustomSelect';

const ID_TYPE_MENU_ITEMS = () => [
  { key: 'I', value: 'I', children: 'NRIC/FIN' },
  { key: 'P', value: 'P', children: 'Passport No.' },
];

const defaultIdType = (userIdType?: string) => (userIdType === 'NRIC/FIN' ? 'I' : 'P');

interface NameAndIdTypeDetailsProps {
  examCandidateDetail: ExamCandidateDetails;
  isEditState?: boolean;
  sameRowName?: boolean;
  isNonNationalExam?: boolean;
  isOpsAdmin?: boolean;
  form?: UseFormReturn<Record<string, any>>;
}

const NameAndIdTypeDetails = ({
  examCandidateDetail,
  isEditState,
  sameRowName,
  isNonNationalExam,
  isOpsAdmin = false,
  form,
}: NameAndIdTypeDetailsProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const { name, hanyuPinyinName, userIdType, nricFinPassport } = examCandidateDetail;

  return (
    <>
      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        labelText={t('exam->>ReviewExam.Name')}
        valueText={name}
        containerClassName={classes.formElementContainer}
        EditComponent={
            form && <TextFieldForm
                form={form}
            isInputTextUpperCase
            onChange={(e) => form?.setValue('name', e.target.value.toUpperCase())}
            label={t('exam->>ReviewExam.Name')}
            name="name"
            defaultValue={name}
            type="text"
            fullWidth
            inputProps={{ readOnly: !isOpsAdmin }}
            error={!!form?.formState.errors.name}
            helperText={form?.formState.errors?.name?.message?.toString()}
            isRequired
            regExpToBlock={nameRegExp}
          />
        }
      />
      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        labelText={t('exam->>ReviewExam.HanyuPinyinName')}
        allHide
        valueText={hanyuPinyinName}
        containerClassName={
          !isEditState
            ? `${classes.formElementContainer} ${sameRowName && classes.halfWidthRightItem}`
            : `${classes.formElementContainer}`
        }
        EditComponent={
            form && <TextFieldForm
                form={form}
            isInputTextUpperCase
            onChange={(e) => form?.setValue('hanyupinyinName', e.target.value.toUpperCase())}
            label={t('exam->>ReviewExam.HanyuPinyinName')}
            defaultValue={hanyuPinyinName}
            error={!!form?.formState.errors.hanyupinyinName}
            helperText={form?.formState.errors?.hanyupinyinName?.message?.toString()}
            name="hanyupinyinName"
            type="text"
            fullWidth
            inputProps={{ readOnly: !isNonNationalExam }}
          />
        }
      />
      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        labelText={t('exam->>ReviewExam.IdType')}
        valueText={userIdType}
        containerClassName={`${classes.formElementContainer} ${classes.halfWidthLeftItem}`}
        EditComponent={
          form && (
            <ControlledCustomSelect
              control={form.control}
              label={t('exam->>ReviewExam.IdType')}
              name="IdType"
              menuItems={ID_TYPE_MENU_ITEMS()}
              defaultValue={defaultIdType(userIdType)}
              variant="filled"
              disabled
              fullWidth
            />
          )
        }
      />
      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        labelText={t('exam->>ReviewExam.NricFinPassportNo')}
        valueText={nricFinPassport}
        containerClassName={`${classes.formElementContainer} ${classes.halfWidthRightItem}`}
        EditComponent={
          form && <TextFieldForm
            form={form}
            label={t('exam->>ReviewExam.NricFinPassportNo')}
            onChange={(e) => form?.setValue('NricFin', e.target.value.toUpperCase())}
            name="NricFin"
            type="text"
            fullWidth
            inputProps={{ readOnly: !isOpsAdmin }}
            error={!!form?.formState.errors.NricFin}
            helperText={form?.formState.errors?.NricFin?.message?.toString()}
            isRequired
          />
        }
      />
    </>
  );
};

export default NameAndIdTypeDetails;
